import type { Category } from './types';

const CATEGORY_ASPECTS: Record<'Phone' | 'Tablet' | 'Laptop' | 'Desktop' | 'Watch' | 'Watches', number> = {
  Phone: 9 / 19.5,
  Tablet: 3 / 4,
  Laptop: 16 / 10,
  Desktop: 16 / 9,
  Watch: 4 / 5,
  Watches: 4 / 5
};

export function getCategoryAspect(category: Category | 'Watch' | 'Watches' | string): number | null {
  return CATEGORY_ASPECTS[category as keyof typeof CATEGORY_ASPECTS] ?? null;
}
